import { render, staticRenderFns } from "./ImpactionPointsDialog.vue?vue&type=template&id=3a778010&scoped=true&"
import script from "./ImpactionPointsDialog.vue?vue&type=script&lang=js&"
export * from "./ImpactionPointsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImpactionPointsDialog.vue?vue&type=style&index=0&id=3a778010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a778010",
  null
  
)

export default component.exports